// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom'

import * as MuiCore from '@material-ui/core';
import {  withStyles } from '@material-ui/core/styles';
import * as coreSelectors from './core/selectors';
import * as coreActions from './core/actions';

import * as phoneSelectors from './phone/selectors';
import * as phoneActions from './phone/actions';

import * as serviceSelectors from './service/selectors';
import * as serviceActions from './service/actions';

import SnackMessages from './core/SnackMessages';
import BusyBox from './core/BusyBox';
import Confirm from './ui/Confirm';
import SaveIdentity from './core/SaveIdentity';
import Settings from './core/Settings';
import PhonePad from './phone/PhonePad';
import ContactLink from './service/ContactLink';

import Dashboard from './service/Dashboard';
import Activity from './service/Activity';
import Contacts from './service/Contacts';
import Account from './account/Account';
import ActivityDetail from './service/ActivityDetail';
import Contact from './service/Contact';
import Status from './service/Status';
import Reports from './account/Reports';
import Assist from './service/Assist';
import SendText from './service/SendText';
import WebLeads from './account/WebLeads';
import BlockNumbers from './service/BlockNumbers';
import Profile from './profile/Profile';
import CompanyProfile from './profile/CompanyProfile';
import RubyStatus from './service/RubyStatus';
import RubySettings from './service/RubySettings';
import CallHandling from './service/CallHandling';
import RubyIntegrations from './service/RubyIntegrations';
import Invoice from './account/Invoice';
import VipContacts from './service/VipContacts';
import Usage from './ui/Usage';
import Texts from 'service/Texts';
import ChatActivity from 'service/ChatActivity';
import UnblockConfirmaton from 'service/UnblockConfirmation';


const styles = theme => ({
  '.MuiListItem-root.Mui-selected': {
    backgroundColor:'white',
    '&:hover': {
      backgroundColor: 'red',
    }
  },

  sideMenuItems:{
    selected: {
      "&&": {
        backgroundColor: "blue",
        color: "white",
        "&& span": {
          color: "white"
        }
      },
      "&&:hover": {
        backgroundColor: "darkblue",
        color: "white"
      }
    }
  },
  
  /* Top level container fills the entire viewport */
  topLevel : {
    display: 'flex',
    flexDirection: 'column',
  },

  /* Top bar with logo, tabs, phone, and user menu */
  topBar : {
    width: `calc(100% - ${theme.sizes.drawerWidth}px)`,
    marginLeft: theme.sizes.drawerWidth,
    background: 'transparent', 
    boxShadow: 'none',
    color:'black'
  },

  warningBar : {
    ...theme.typography.body2,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.constrastText,
    fontWeight: 'bold',
    padding: 10,
    marginLeft: 90
  },

  /* Bottom app bar with phone number */
  bottomBar : {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap:'wrap',
    paddingLeft: 40,
    paddingRight: 40,
  },
  
  /* Top left logo */
  navigationLogo: {
    backgroundColor:theme.palette.primary.main,
    marginTop: 20,
    marginLeft: 70,
    marginBottom: 20,
    margin:theme.spacing(1),
  },

  mobileLogo: {
    padding:theme.spacing(2),
    maxWidth:'150px',
  },
  mobileLogoHolder: {

  },

  sidebar:{
    // borderRadius:'0px 60px 0px 0px'
  },



  /* Buttons across the top to select the section */
  navigationButton : {
    textTransform: 'none',
    color : theme.palette.primary.contrastText,
    textDecoration: 'none',        
  },
  navigationButtonActive : {
    textTransform: 'none',
    color : theme.palette.secondary.light + ' !important',
    textDecoration: 'none',    
  },
  navigationButtonLabel : {
    textShadow : 'none',
  },
  navigationButtonLabelActive : {
    textShadow : 'none',
    color : theme.palette.secondary.light,
  },

  /* Line under the navigation button */
  selectedLine : {
    backgroundColor : theme.palette.secondary.main,
    width: '25px',
    left: 'auto',
    right: 'auto',
    height: 2,
  },
  unSelectedLine : {
    width: '25px',
    left: 'auto',
    right: 'auto',
    height: 2,
  },

  /* Right side user menu */
  userMenuButton : {
    marginLeft: 10,
    marginRight: 20,
    paddingLeft: 20,
    textTransform: 'none',
    borderWidth: 2,
    borderRadius: 50,
    color : 'black',
    fontFamily: 'Sofia',
    textDecoration: 'none',    
  },

  /* Clickable phone number on the bottom right */
  phoneNumberLink : {
    color : theme.palette.primary.contrastText,
  },
  drawer: {
    width: theme.sizes.drawerWidth,
    flexShrink: 0,
    backgroundColor:'#7f2062'
  },
  drawerPaper: {
    width: theme.sizes.drawerWidth,
    backgroundColor:'#7f2062'
  },
 

});

/*
 * Top level screen when logged in
 */

class MainScreen extends Component {
  constructor (props) {
    super(props);
    this.userButtonRef = React.createRef();
    this.accountButtonRef = React.createRef();
  }

  state = {
    userMenuOpen : false,
    accountMenuOpen : false,
    settingsOpen : false,
    confirmLogout : false,
    anchor:false,
    hostsOnTest: ['dev', 'test', 'beta'],
    newScreens: ['company', 'settings', 'reports', 'billing', 'integrations', 'account', 'profile']
  }

  componentDidUpdate() {
    if(this.props.user.userAccountRoles.filter(role => role.userRoleKey === 'BILLING_ADMIN').length === this.props.user.userAccountRoles.length && (!window.location.href.includes(["/billing"]) && !window.location.href.includes(["/profile"]))){
      this.props.history.push("/billing");
    }
    if(this.props.user.userAccountRoles.filter(role => role.userRoleKey === 'PARTNERS').length === this.props.user.userAccountRoles.length && (window.location.href.includes("/billing") || window.location.href.includes("/reports"))){
      this.props.history.push("/");
    }
    if(this.props.user.userAccountRoles.filter(role => role.userRoleKey === 'GRASSHOPPER').length === this.props.user.userAccountRoles.length && (window.location.href.includes("/billing") || window.location.href.includes("/reports"))){
      this.props.history.push("/");
    }
    if(this.props.user.userAccountRoles.filter(role => role.userRoleKey === 'GRASSHOPPERSMS').length === this.props.user.userAccountRoles.length && (window.location.href.includes("/billing") || window.location.href.includes("/reports"))){
      this.props.history.push("/");
    }
  }

  componentDidMount() {
    var accounts = [];
    if(this.props.user.userAccountRoles.filter(role => role.userRoleKey === 'BILLING_ADMIN').length === this.props.user.userAccountRoles.length){
      this.props.history.push("/billing");
    }
    for(var i = 0;i < this.props.user.userAccountRoles.length;i++){
      accounts.push(this.props.user.userAccountRoles[i].accountId);
    }
    window.pendo.initialize({
      visitor: {
        id: this.props.user.userId
      },
      account: {
        id: accounts.join(",")
      }
    })
  }
  

  render() {
    const { user, logout, history, phoneAnchorEl, agentUserSession, ackNotification, isMobile } = this.props;

    return (
      <React.Fragment>
        <SnackMessages/>
        <BusyBox/>
        <SaveIdentity/>
        <ActivityDetail/>
        <Contact />
        <Status/>
        <Assist/>
        <UnblockConfirmaton />
        <ContactLink/>
        <SendText/>
        <Invoice />
        <Usage open={user.usageNotifications?.length > 0 && !Boolean(agentUserSession)} 
               usageNotification={user?.usageNotifications?.[0] || {}}
               user={user}
               ackFunction={() => ackNotification(user.usageNotifications[0]?.usageNotificationId)}
               usage={() => {ackNotification(user.usageNotifications[0]?.usageNotificationId);history.push('/reports')}} />
        {/* The anchor element is removed from the phonepad */}
        <PhonePad isMobile={isMobile} anchorEl={phoneAnchorEl.current}/>
        <Settings open={this.state.settingsOpen}
                  onClose={() => this.setState({settingsOpen : false})}/>
        <Confirm open={this.state.confirmLogout}
                 onCancel={() => this.setState({confirmLogout : false})}
                 title='Logout'
                 text='Are you sure you want to log out?'
                 confirmLabel='Logout'
                 onConfirm={() => logout()}/>

        <MuiCore.Popover anchorEl={this.userButtonRef.current}
                         anchorOrigin={{ horizontal: 'center',
                                         vertical: 'bottom'}}
                         transformOrigin = {{
                           vertical : 'top',
                           horizontal : 'center',
                         }}
                         open={this.state.userMenuOpen}
                         onClose={() => this.setState({userMenuOpen : false})}>
          <MuiCore.MenuList>
            <MuiCore.MenuItem
              onClick={() => {history.push('/profile');this.setState({userMenuOpen: false})}}>
              <MuiCore.ListItemText style={{fontFamily: 'Sofia'}}>
              <span style={{fontFamily: 'Sofia'}}>My Profile</span>
              </MuiCore.ListItemText>
            </MuiCore.MenuItem>
            <MuiCore.MenuItem
              onClick={() => {window.open("https://www.ruby.com"); this.setState({userMenuOpen: false})}}>
              <MuiCore.ListItemText style={{fontFamily: 'Sofia'}}>
                <span style={{fontFamily: 'Sofia'}}>www.ruby.com</span>
              </MuiCore.ListItemText>
            </MuiCore.MenuItem>
            <MuiCore.MenuItem
              onClick={() => this.setState({userMenuOpen: false, confirmLogout : true})}>
              <MuiCore.ListItemText>
                <span style={{fontFamily: 'Sofia'}}>Logout</span>
              </MuiCore.ListItemText>
            </MuiCore.MenuItem>
          </MuiCore.MenuList>
        </MuiCore.Popover>
         
            <Switch>
              <Route path="/activity">
                <Activity />
              </Route>
              <Route path="/chat-activity">
                <ChatActivity/>
              </Route>
              <Route path="/text-activity">
                <Texts/>
              </Route>
              <Route path="/contacts">
                <Contacts/>
              </Route>
              <Route path="/blocked">
                <BlockNumbers/>
              </Route>
              <Route path="/status">
                <RubyStatus/>
              </Route>
              <Route path="/integrations">
                <RubyIntegrations/>
              </Route>
              <Route path="/billing">
                <Account/>
              </Route>
              <Route path="/reports">
                <Reports />
              </Route>
              <Route path="/leads">
                <WebLeads />
              </Route>
              <Route path="/profile">
                <Profile />
              </Route>
              <Route path="/company">
                <CompanyProfile />
              </Route>
              <Route path='/settings'>
                <RubySettings />
              </Route>
              <Route path='/callhandling'>
                <CallHandling />
              </Route>
              <Route path='/vip'>
                <VipContacts />
              </Route>
              <Route>
                <Dashboard/>
              </Route>
            </Switch>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    user : coreSelectors.getUser(state),
    availableScreens : coreSelectors.getAvailableScreens(state),
    callState : phoneSelectors.getCallState(state),
    phoneOpen : phoneSelectors.getPhoneOpen(state),
    apiInfo : coreSelectors.getApiInfo(state),
    agentUserSession : coreSelectors.getAgentUserSession(state),
    unreadMessageCount : serviceSelectors.getUnreadMessageCount(state),
    unreadChatCount : serviceSelectors.getUnreadChatCount(state),
  });
};

const mapDispatchToProps = {
  logout : coreActions.logout,
  setPhoneOpen : phoneActions.setPhoneOpen,
  dumpState : coreActions.dumpState,
  openAssist : serviceActions.openAssist,
  ackNotification: coreActions.ackNotification,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(MainScreen)))

